import React, { Component } from 'react'
import { Modal } from "react-bootstrap";
import "./_Diary_NoticeResponse.scss";

class DiaryResponseModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            seenUnseenId: "0",
            count: 0,
            viewStatus: false,
            dataClear: 0,
        }
    }

    handleSelect(val) {
        this.setState({ seenUnseenId: val == "0" ? "0" : "1" })
    }

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({ seenUnseenId: this.props.defaultTabId || "0", dataClear: 1 })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    render() {

        console.log("Student Dairyyyyyyy ", this.props.stateData.studentDairyNoticeSubmissionDetails);
        let studentCreation = this.props.stateData?.studentDairyNoticeCreationDetails.filter(
            (item) => item.dairyAssigment_id == this.props.stateData.deleteId
        );

        let seenStudents = this.props.stateData.studentDairyNoticeSubmissionDetails.filter(
            (item) => item.status == 1 && item.dairy_assignment_id == this.props.stateData.deleteId
        );

        let totalStudents = this.props.stateData.studentDiaryNoticeViewStatus;
        let nonseenStudents = [];

        if (studentCreation.length > 0) {
            let seenStudentsdata = seenStudents.map((item) => item.edu_student_id).toString();
            nonseenStudents = totalStudents
                // .filter((item) => studentCreation[0].exam_id.includes(item.exam_id))
                .filter((item1) => studentCreation[0].class_id.includes(item1.class_id))
                .filter((item2) => studentCreation[0].section_ids.includes(item2.section_id))
                .filter((item3) => !seenStudentsdata.includes(item3.edu_student_id));
        }

        const isUnseen = this.state.seenUnseenId === "0";
        const tableData = isUnseen ? nonseenStudents : seenStudents.filter((item) => item.status == "1");

        return (
            <Modal {...this.props} size="lg" aria-labelledby="response-modal-title">
                {/* ── Header ── */}
                <Modal.Header closeButton className="resp-modal-header">
                    <div className="resp-header-icon">👁️</div>
                    <div className="resp-header-info">
                        <p className="resp-title">Student View Status</p>
                        <p className="resp-subtitle">Track who has seen this entry</p>
                    </div>
                </Modal.Header>

                {/* ── Body ── */}
                <Modal.Body style={{ maxHeight: 580, overflowY: "auto" }} className="p-4">

                    {/* Status toggle tabs */}
                    <div className="resp-status-tabs">
                        <div
                            className={`resp-status-tab unseen${this.state.seenUnseenId === "0" ? " active" : ""}`}
                            onClick={() => this.handleSelect("0")}
                        >
                            <div className="rst-icon">
                                <i className="fas fa-eye-slash" style={{ color: "#d97706" }} />
                            </div>
                            <div className="rst-info">
                                <p className="rst-label">Not Seen</p>
                                <p className="rst-count">{nonseenStudents.length}</p>
                            </div>
                        </div>

                        <div
                            className={`resp-status-tab seen${this.state.seenUnseenId === "1" ? " active" : ""}`}
                            onClick={() => this.handleSelect("1")}
                        >
                            <div className="rst-icon">
                                <i className="fas fa-eye" style={{ color: "#059669" }} />
                            </div>
                            <div className="rst-info">
                                <p className="rst-label">Seen</p>
                                <p className="rst-count">{seenStudents.length}</p>
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    {tableData.length > 0 ? (
                        <div className="resp-table-wrap">
                            <table className={`resp-table ${isUnseen ? "unseen" : "seen"}`}>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Roll No</th>
                                        <th>Student Name</th>
                                        <th>Parent Name</th>
                                        <th>Parent Mobile</th>
                                        {!isUnseen && <th>Comments</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item?.roll_no}</td>
                                            <td>{item?.student_name}</td>
                                            <td>{item?.parent_name}</td>
                                            <td>{item?.parent_mobile}</td>
                                            {!isUnseen && (
                                                <td>
                                                    <span className="resp-comment">
                                                        {item?.comments || "—"}
                                                    </span>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="resp-empty">
                            <div className="resp-empty-icon">
                                {isUnseen ? "✅" : "📭"}
                            </div>
                            <div className="resp-empty-title">
                                {isUnseen ? "All students have seen this!" : "No students have seen this yet"}
                            </div>
                            <div className="resp-empty-sub">
                                {isUnseen
                                    ? "Every student has viewed this entry."
                                    : "Once students view this entry, they'll appear here."}
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        )
    }
}

export default DiaryResponseModal;
